import {CurationActionCreatorService} from '../curation/services/curation-action-creator.service';
import {WorkflowConfigService} from '@ispm/workflow/services/workflow-config.service';
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";
import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';


@Injectable({providedIn: 'root'})
export class resolveCurationDefinition {
  constructor(private navigationConfigService: NavigationConfigService,
              private curationAC: CurationActionCreatorService) {
  }

  resolve() {
    const params: string = 'context=' + this.navigationConfigService.getCurrentApplicationId();
    return this.curationAC.setCurationDefinition(params)
      .map((res) => {
      })
      .toPromise();
  }
}

@Injectable({providedIn: 'root'})
export class resolveCurationKbDefinition {
  constructor(private curationAC: CurationActionCreatorService) {
  }

  resolve(trans: ActivatedRoute) {
    const activeKB: any = trans.params['KB'];
    if (typeof activeKB === 'string') {
      this.curationAC.setStateActiveKB(activeKB);
    }

    return this.curationAC.setCurationDefinition()
      .map((res) => {
      })
      .toPromise();
  }
}


@Injectable({providedIn: 'root'})
export class resolveWorkflowConfigInit {
  constructor(private workflowConfig: WorkflowConfigService) {
  }

  resolve(activatedRoute: ActivatedRoute) {
    return this.workflowConfig.changeWorkflow(activatedRoute.params['workflowRequestId'], activatedRoute.params['revisionId']).toPromise();
  }
}


